import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
// import { useFormik } from "formik";
// import * as Yup from "yup";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken  } from "../Global";

import AWS from 'aws-sdk';
import { AWS_ACCESS_KEY_ID, AWS_SECRET_ACCESS_KEY, AWS_DEFAULT_REGION,AWS_BUCKET } from "../Global";

import "react-toastify/dist/ReactToastify.css";

const ProductListingGroupBY = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);


  const [permission, setPermission] = useState({});

  useEffect(() => {
        setPermission(FindModuleById(5)); 
console.log(permission);

   
    axios
      .get(`/products/listing-products/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        setData(response.data.data.products);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

 

   const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  
    let raw_data_invoice ='';
     if(data.file){
       AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
       AWS.config.update({
       accessKeyId: AWS_ACCESS_KEY_ID,
       secretAccessKey: AWS_SECRET_ACCESS_KEY,
       region: AWS_DEFAULT_REGION,
       signatureVersion: 'v4',
       });
       const s3 = new AWS.S3();
       var params = {Bucket: AWS_BUCKET, Key: data.file};
       raw_data_invoice = s3.getSignedUrl('getObject', params);
     
     }
   const viewFile =(link) =>{
      AWS.config.setPromisesDependency(); //use so you can promisify to get the actual images
      AWS.config.update({
      accessKeyId: AWS_ACCESS_KEY_ID,
      secretAccessKey: AWS_SECRET_ACCESS_KEY,
      region: AWS_DEFAULT_REGION,
      signatureVersion: 'v4',
      });
      const s3 = new AWS.S3();
      var params = {Bucket: AWS_BUCKET, Key: link};
      return  s3.getSignedUrl('getObject', params);
    }
  
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /> 
         {/* <ToastContainer /> */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Products View Page</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/products">Products</Link>
                    </li>
                    <li className="breadcrumb-item active">Products View Page</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    {permission && permission.list === 1 && (
                      <div className="table-responsive">
                      <table className="table table-bordered">
                      <tbody>
                      <tr>
                          <th className="p-3">Name</th>
                          <td className="p-3">{data.name}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Description</th>
                          <td className="p-3">{data.description}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Type</th>
                          <td className="p-3">
                            {data.type ? data.type.title : ""}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Attach Product&apos;s specs</th>
                          <td className="p-3">
                           {raw_data_invoice != '' && (
                             
                                <a
                                  className="btn btn-primary invoicebtn"
                                  href={raw_data_invoice}
                                  target="_blank"
                                   rel="noopener noreferrer"
                                  download
                                >
                                  Download
                                </a>
                             
                          )}
                          </td>
                        </tr>
                      
                       

                  </tbody>
                  </table>
                    <br />
                        <h5 className="card-title">Images</h5>

                        <table className="table table-bordered">
                          <tr>
                            
                         
                          {data.files &&
                            data.files.map((item, palletIndex) => (
                             
                                <td className="p-3"   key={palletIndex} >
                        
                        
                                {item && ( <img style={{width:'300px'}} src={viewFile(item.link) }/>)}

                                </td>
                        
                            ))}
                             </tr>
                        </table>
                     
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductListingGroupBY;
